<template>
  <tr class="perm-item-row">
    <td class="perm-td-feature">
      <span class="perm-feature-indent"></span>
      <span class="perm-feature-name">{{ item.name }}</span>
    </td>
    <td
      v-for="role in item.roles"
      :key="role.roleId"
      v-show="visibleRoleIds.has(role.roleId)"
      class="perm-td-role text-center"
    >
      <input
        type="checkbox"
        class="perm-checkbox"
        :checked="role.checked"
        :disabled="isDisabled(role)"
        :style="{ '--role-color': roleColorMap.get(role.roleId) }"
        @change="onCheckChange($event.target.checked, role)"
      />
    </td>
  </tr>
</template>

<script>
import { PERMISSION_TYPE } from '@/core/plugins/constants';

export default {
  name: 'PermissionRow',
  props: {
    item: { type: Object, required: true },
    visibleRoleIds: { type: Set, required: true },
    roleColorMap: { type: Map, required: true },
  },
  methods: {
    getDisplayRoleName(fullName) {
      if (!fullName) return fullName;
      const idx = fullName.indexOf('_');
      return idx > 0 ? fullName.substring(0, idx) : fullName;
    },
    isDisabled(role) {
      const shortName = this.getDisplayRoleName(role.roleName);
      if (shortName === 'Admin') {
        return this.item.nameType !== PERMISSION_TYPE.ASSIGN;
      }
      return shortName !== 'Manager' && this.item.nameType === PERMISSION_TYPE.ASSIGN;
    },
    onCheckChange(checked, role) {
      this.$emit('role-change', { checked, role, item: this.item });
    },
  },
};
</script>

<style lang="scss" scoped>
.perm-item-row {
  border-bottom: 1px solid #f0f0f0;
  &:hover {
    background: #fafbff;
  }
}
.perm-td-feature {
  padding: 6px 16px;
  color: #3f4254;
  display: flex;
  align-items: center;
  gap: 8px;
}
.perm-feature-indent {
  width: 40px;
  display: inline-block;
}
.perm-feature-name {
  font-size: 12px;
  color: #7e8299;
  background: #f3f6f9;
  padding: 3px 10px;
  border-radius: 4px;
  font-weight: 500;
}
.perm-td-role {
  padding: 4px;
}
.perm-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--role-color, #008479);
  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
}
</style>
